import React from 'react';
import Css from '@components/Footer/Desktop/Desktop.scss';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const footerSimple = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={Css.footer + ' pl-3 pr-3'}>
      <Row className={'align-items-center'} style={{ height: '100%' }}>
        <Col className={'text-center'} style={{ whiteSpace: 'nowrap' }}>
          &nbsp;
        </Col>
      </Row>
    </footer>
  );
};
export default footerSimple;



// WEBPACK FOOTER //
// ./src/components/Footer/FooterSimple.jsx